<template>
  <WishList :list="list" />
</template>


<script>
import WishList from './components/WishList.vue'
import { wishlistDb } from '@/firebase';
import { onValue, } from 'firebase/database';
import { ref } from 'vue'
// import InlineSvg from "vue-inline-svg";
// Vue.component("inline-svg", InlineSvg);


const list = ref({})

onValue(wishlistDb, (snapshot) => {
  const data = snapshot.val();
  // console.log("data firebase update", data);
  Object.assign(list.value, data);
});



export default {
  name: 'App',
  data() {
    return {
      list,
    }
  },
  components: {
    WishList,
    // InlineSvg
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
